import {ref} from 'vue';
import {useRefDom} from './useRefDom';

export function useScroll(target) {
  const scrollTop = ref(0);
  const scrollLeft = ref(0);

  // TODO: config throttle

  function handler(el) {
    scrollTop.value = el.target.scrollTop;
    scrollLeft.value = el.target.scrollLeft;
  }

  function cleanup(dom) {
    dom?.removeEventListener('scroll', handler);
  }

  function onChange(dom) {
    dom?.addEventListener('scroll', handler);
  }

  const { stop } = useRefDom({ target: ref(target), cleanup, onChange });

  return {
    stop,
    scrollTop,
    scrollLeft,
  };
}
